import React from 'react'
import { Card, List, Icon } from 'semantic-ui-react';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import { dispatch } from '@rematch/core';

class ContentCard extends React.Component {

    async goToContent(id, data) {
        await dispatch.home.redirectFromEventStream(true);
        let pLoad = {
            id: id,
            data: data
        }
        await dispatch.content.isContentAvailable(pLoad);
    }

    render() {
        return (
            <div className="imageBlock cursor-pointer" onClick={() => this.goToContent(this.props.selectedContent._id, this.props.selectedContent)}>
                <Card className=" appDefaultCard">
                    <Card.Header>
                        <EllipsisTooltip
                            name={this.props.selectedContent.name}
                        />
                    </Card.Header>
                    <Card.Content style={{background:"#E8EBF1"}}>
                        <List style={{ margin: "10px 0 0 0" }}>
                            <List.Item style={{ padding: "10px" }}>
                                <Icon name="linkify" style={{ padding: "2px 5px 0 0px" }} />
                                <List.Content verticalAlign='middle'>
                                    <EllipsisTooltip
                                        name={this.props.selectedContent.contentpath}
                                        line={2}
                                        style={{ lineHeight: "16px" }} />
                                </List.Content>
                            </List.Item>
                            <List.Item style={{ padding: "10px" }}>
                                <Icon name="file" style={{ padding: "2px 5px 0 0px" }} />
                                <List.Content verticalAlign='middle'>{this.props.selectedContent.type}</List.Content>
                            </List.Item>
                        </List>
                    </Card.Content>
                </Card>
            </div>
        )
    }
}

export default ContentCard;